import ExtraArtist from "./ExtraArtist";

const Artists = ({ concert, t, i18n }) => {
  return (
    <>
      {concert.artists.length > 0 && (
        <>
          <h4 className="text-capitalize titlenotaligned mt-5">
            {t("concerts.artists")}
          </h4>

          <ExtraArtist concert={concert} t={t} i18n={i18n} />

          {concert.artists.map(({ name, instrument, id }) => (
            <div key={id}>
              {name === "orchestra_busoni" ? (
                <>
                  <div className="text-left">
                    <h5 style={{ color: "#131313", fontWeight: "500" }}>
                      {t(`concerts.${name}`)}
                    </h5>
                  </div>
                </>
              ) : (
                <div className="row artist-row mb-2">
                  <div className="col-12 col-md-4">
                    <h5 className="artist-name colorok mb-1">{name}</h5>
                  </div>
                  <div className="col-12 col-md-8">
                    <h5 className="artist-instrument colorok mb-0">{t(`concerts.${instrument}`)}</h5>
                  </div>
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default Artists;
